export default "__VITE_ASSET__DBGeaCei__"